// extracted by mini-css-extract-plugin
module.exports = {"containerWrap":"followArtist_containerWrap__3BOrB","title":"followArtist_title__23SS9","read":"followArtist_read__3Dew-","button":"followArtist_button__P7as4"};